export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      communities: "Communautés",
      programs: "Programmes",
      events: "Événements",
      gallery: "Galerie",
      videos: "Vidéos",
      contact: "Contact",
      admin: "Admin",
      login: "Connexion",
      logout: "Déconnexion",
    },
    hero: {
      welcome: "Bienvenue à Emmaüs",
      subtitle: "Une église, une famille, une mission",
      verse: "Car là où deux ou trois sont assemblés en mon nom, je suis au milieu d'eux.",
      verseRef: "Matthieu 18:20",
      ctaPrimary: "Nous rejoindre",
      ctaSecondary: "En savoir plus",
    },
    sections: {
      programs: "Nos Programmes",
      events: "Événements à venir",
      videos: "Messages récents",
      gallery: "Galerie photos",
      pastor: "Message pastoral",
      communities: "Nos communautés",
    },
    common: {
      readMore: "Lire plus",
      viewAll: "Voir tout",
      discover: "Découvrir",
      join: "Rejoindre",
      contactUs: "Contactez-nous",
      send: "Envoyer",
      name: "Nom",
      email: "Email",
      phone: "Téléphone",
      subject: "Sujet",
      message: "Message",
      address: "Adresse",
      followUs: "Suivez-nous",
      quickLinks: "Liens rapides",
      language: "Langue",
      newsletter: "Newsletter",
      subscribe: "S'abonner",
      search: "Rechercher",
      loading: "Chargement...",
      error: "Une erreur est survenue",
      success: "Opération réussie",
      close: "Fermer",
      previous: "Précédent",
      next: "Suivant",
      add: "Ajouter",
      edit: "Modifier",
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      back: "Retour",
      none: "Aucun",
      confirm: "Confirmer",
      all: "Tous",
      recent: "Récents",
      justNow: "À l'instant",
      minutesAgo: "min",
      hoursAgo: "h",
      daysAgo: "j",
      noSubject: "Sans sujet",
      noLocation: "Lieu non précisé",
      title: "Titre",
      description: "Description",
      location: "Lieu",
      date: "Date",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      image: "Image",
      category: "Catégorie",
      day: "Jour",
      leader: "Responsable",
      time: "Heure",
      videoUrl: "URL de la vidéo",
      active: "Actif",
      inactive: "Inactif",
      visible: "visible sur le site",
      optional: "optionnel",
      choose: "Choisir",
      siteName: "Nom du site",
      logoUrl: "Logo URL",
      primaryColor: "Couleur principale",
      secondaryColor: "Couleur secondaire",
      footerText: "Texte du footer",
      program: "Programme",
      reply: "Réponse",
      welcome: "Bienvenue dans l'administration",
      adminWelcome: "Utilisez le menu de gauche pour gérer le contenu du site. Les messages de contact, les événements, les programmes, les communautés, la galerie et les vidéos peuvent tous être ajoutés, modifiés ou supprimés depuis leurs pages respectives.",
      preview: "Aperçu",
      carouselPreview: "Aperçu du carrousel",
      last30Days: "30 derniers jours",
      messageEvolution: "Évolution des messages",
      eventEvolution: "Évolution des événements",
      testimonialEvolution: "Évolution des témoignages",
      messageDistribution: "Répartition des messages",
      byStatus: "Par statut",
      new: "Nouveaux",
      replied: "Répondus",
      archived: "Archivés",
      folder: "Dossier",
      coverImage: "Image de couverture",
      avatarUrl: "URL de l'avatar",
      testimonial: "Témoignage",
      role: "Rôle",
      photos: "photos",
      watch: "Regarder",
      weeklySchedule: "Planning hebdomadaire",
      seeEvents: "Voir les événements",
      joinUs: "Venez nous rejoindre",
      register: "S'inscrire",
      detailedProgram: "Programme détaillé",
      info: "Informations",
      imageOptional: "Image (optionnel)",
      googleMaps: "Google Maps",
      sending: "Envoi en cours...",
      messageSent: "Message envoyé !",
      sendError: "Une erreur est survenue lors de l'envoi",
      privacy: "Privacy",
      terms: "Terms",
      testimonials: "Témoignages de vie",
      testimonialsSubtitle: "Des vies transformées par la grâce de Dieu au sein de notre communauté",
      upcoming: "À venir",
      past: "Passés",
      noEvents: "Aucun événement dans cette catégorie",
      noPhotos: "Aucune photo dans ce dossier",
      notFound: "non trouvé",
      backTo: "Retour aux",
    },
    footer: {
      about: "À propos d'Emmaüs",
      aboutText: "Emmaüs est une église chrétienne évangélique qui proclame Christ et édifie des disciples depuis plus de 20 ans.",
      serviceTimes: "Horaires du culte",
      sunday: "Dimanche",
      wednesday: "Mercredi",
      contact: "Contact",
      rights: "Tous droits réservés",
    },
    about: {
      title: "À propos d'Emmaüs",
      subtitle: "Découvrez l'histoire, la vision et la mission de notre église",
      history: "Notre histoire",
      historyText1: "Fondée en 2004, l'église Emmaüs est née d'une vision simple mais profonde : créer un lieu où chacun peut rencontrer Dieu, grandir en foi et vivre en communauté. Ce qui a commencé comme un petit groupe de prière dans un salon est devenu aujourd'hui une famille de plusieurs centaines de personnes.",
      historyText2: "Au fil des années, Emmaüs a connu une croissance remarquable, non seulement en nombre mais surtout en impact spirituel. Nous avons vu des vies transformées, des familles restaurées et des communautés bénies par l'œuvre de Dieu.",
      historyText3: "Aujourd'hui, Emmaüs continue d'être un phare d'espérance dans notre ville, accueillant chaque semaine des visiteurs de tous horizons, unis par la même foi et la même mission.",
      vision: "Notre vision",
      mission: "Notre mission",
      values: "Nos valeurs",
      pastor: "Notre pasteur",
      goals: "Objectifs spirituels",
      joinMission: "Rejoignez notre mission",
      valuesList: {
        love: { title: "Amour", desc: "Nous croyons en l'amour inconditionnel de Dieu et nous cherchons à aimer les autres comme Christ nous a aimés." },
        word: { title: "Parole de Dieu", desc: "La Bible est notre fondement. Nous étudions, enseignons et appliquons la Parole dans toutes les sphères de la vie." },
        community: { title: "Communauté", desc: "Nous sommes une famille de foi où chacun trouve sa place, son soutien et sa croissance spirituelle." },
        service: { title: "Service", desc: "Nous servons notre communauté avec humilité et compassion, portant l'espérance là où elle est nécessaire." },
        mission: { title: "Mission", desc: "Nous sommes appelés à proclamer l'Évangile dans toutes les nations et à faire des disciples." },
        excellence: { title: "Excellence", desc: "Nous cherchons à honorer Dieu par l'excellence dans tout ce que nous entreprenons." },
      },
      goalsList: [
        "Édifier des disciples fervents et engagés",
        "Proclamer l'Évangile à notre communauté",
        "Former des leaders spirituels de qualité",
        "Impacter la société par des actions concrètes",
        "Soutenir les missions nationales et internationales",
      ],
      pastorBio1: "Pasteur Jean Dupont sert le Seigneur depuis plus de 25 ans. Avec un doctorat en théologie et un cœur passionné pour les âmes, il a fondé Emmaüs avec la vision de voir une église vivante et dynamique.",
      pastorBio2: "Son enseignement est à la fois profond et accessible, touchant des centaines de vies chaque année. Il croit fermement que chaque croyant a un appel unique et un potentiel extraordinaire en Christ.",
      pastorBio3: "\"Ma plus grande joie est de voir des personnes découvrir leur identité en Christ et marcher dans leur destinée.\"",
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Nous sommes là pour vous",
      info: "Informations de contact",
      form: "Envoyez-nous un message",
      map: "Notre emplacement",
    },
    events: {
      subtitle: "Rejoignez-nous pour des moments de célébration, de formation et de communion",
      backToEvents: "Retour aux événements",
      eventNotFound: "Événement non trouvé",
    },
    programs: {
      subtitle: "Découvrez nos différents programmes et rejoignez-nous pour grandir ensemble",
      ctaTitle: "Venez nous rejoindre",
      ctaSubtitle: "Tous nos programmes sont ouverts à tous. Venez comme vous êtes et laissez-vous enrichir par la communauté.",
    },
    communities: {
      subtitle: "Rejoignez une communauté où vous pourrez grandir, partager et servir ensemble",
      intro: "Chez Emmaüs, nous croyons que la croissance spirituelle se fait mieux en communauté. Chaque groupe offre un espace sûr pour se connecter, étudier la Parole, prier ensemble et soutenir les uns les autres dans la foi.",
      notFound: "Vous ne trouvez pas votre communauté ?",
      notFoundDesc: "Contactez-nous et nous vous aiderons à trouver le groupe qui correspond à votre saison de vie.",
    },
    videos: {
      subtitle: "Revivez nos prédications, enseignements et moments de louange",
      subscribeTitle: "Abonnez-vous à notre chaîne",
      subscribeDesc: "Ne manquez aucun message. Recevez une notification à chaque nouvelle vidéo publiée.",
    },
    gallery: {
      subtitle: "Retour en images sur nos moments de célébration et de communion",
      backToGallery: "Retour à la galerie",
      folderNotFound: "Dossier non trouvé",
    },
    login: {
      adminSpace: "Espace administrateur",
      email: "Email",
      password: "Mot de passe",
      loggingIn: "Connexion...",
      noAccount: "Pas encore de compte ?",
      signUp: "S'inscrire",
      backToSite: "Retour au site",
      loginError: "Échec de la connexion",
      forgotPassword: "Mot de passe oublié ?",
      resetPassword: "Réinitialiser le mot de passe",
      resetPasswordDesc: "Entrez votre email pour recevoir un lien de réinitialisation.",
      resetPasswordSent: "Email envoyé ! Vérifiez votre boîte de réception et vos spams.",
      sendResetLink: "Envoyer le lien",
    },
    register: {
      createAccount: "Créer un compte admin",
      accessAdmin: "Accédez à l'espace d'administration du site",
      emailAddress: "Adresse email",
      password: "Mot de passe",
      minChars: "Minimum 6 caractères",
      confirmPassword: "Confirmer le mot de passe",
      creatingAccount: "Inscription en cours...",
      createMyAccount: "Créer mon compte",
      alreadyAccount: "Déjà un compte ?",
      signIn: "Se connecter",
      verifyEmail: "Vérifiez votre email",
      verifyEmailDesc: "Un email de confirmation a été envoyé à {email}. Cliquez sur le lien dans l'email pour activer votre compte, puis connectez-vous.",
      verifyEmailNote: "Remarque",
      verifyEmailSpam: "Si vous ne recevez pas l'email, vérifiez vos spams. Le lien est valide 24h.",
      goToLogin: "Aller à la page de connexion",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères",
      registerError: "Échec de l'inscription",
      backToSite: "Retour au site",
    },
    admin: {
      dashboard: "Tableau de bord",
      messages: "Messages",
      events: "Événements",
      programs: "Programmes",
      communities: "Communautés",
      gallery: "Galerie",
      videos: "Vidéos",
      users: "Utilisateurs",
      testimonials: "Témoignages",
      settings: "Paramètres",
    },
    language: {
      fr: "Français",
      en: "English",
      de: "Deutsch",
      zh: "中文",
      es: "Español",
      it: "Italiano",
      pt: "Português",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      communities: "Communities",
      programs: "Programs",
      events: "Events",
      gallery: "Gallery",
      videos: "Videos",
      contact: "Contact",
      admin: "Admin",
      login: "Login",
      logout: "Logout",
    },
    hero: {
      welcome: "Welcome to Emmaüs",
      subtitle: "One church, one family, one mission",
      verse: "For where two or three are gathered together in my name, there am I in the midst of them.",
      verseRef: "Matthew 18:20",
      ctaPrimary: "Join us",
      ctaSecondary: "Learn more",
    },
    sections: {
      programs: "Our Programs",
      events: "Upcoming events",
      videos: "Recent messages",
      gallery: "Photo gallery",
      pastor: "Pastoral message",
      communities: "Our communities",
    },
    common: {
      readMore: "Read more",
      viewAll: "View all",
      discover: "Discover",
      join: "Join",
      contactUs: "Contact us",
      send: "Send",
      name: "Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Message",
      address: "Address",
      followUs: "Follow us",
      quickLinks: "Quick links",
      language: "Language",
      newsletter: "Newsletter",
      subscribe: "Subscribe",
      search: "Search",
      loading: "Loading...",
      error: "An error occurred",
      success: "Operation successful",
      close: "Close",
      previous: "Previous",
      next: "Next",
      add: "Add",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      back: "Back",
      none: "None",
      confirm: "Confirm",
      all: "All",
      recent: "Recent",
      justNow: "Just now",
      minutesAgo: "min ago",
      hoursAgo: "h ago",
      daysAgo: "days ago",
      noSubject: "No subject",
      noLocation: "Location not specified",
      title: "Title",
      description: "Description",
      location: "Location",
      date: "Date",
      startTime: "Start time",
      endTime: "End time",
      image: "Image",
      category: "Category",
      day: "Day",
      leader: "Leader",
      time: "Time",
      videoUrl: "Video URL",
      active: "Active",
      inactive: "Inactive",
      visible: "visible on the site",
      optional: "optional",
      choose: "Choose",
      siteName: "Site name",
      logoUrl: "Logo URL",
      primaryColor: "Primary color",
      secondaryColor: "Secondary color",
      footerText: "Footer text",
      program: "Program",
      reply: "Reply",
      welcome: "Welcome to the administration",
      adminWelcome: "Use the left menu to manage the site content. Contact messages, events, programs, communities, gallery and videos can all be added, edited or deleted from their respective pages.",
      preview: "Preview",
      carouselPreview: "Carousel preview",
      last30Days: "Last 30 days",
      messageEvolution: "Message evolution",
      eventEvolution: "Event evolution",
      testimonialEvolution: "Testimonial evolution",
      messageDistribution: "Message distribution",
      byStatus: "By status",
      new: "New",
      replied: "Replied",
      archived: "Archived",
      folder: "Folder",
      coverImage: "Cover image",
      avatarUrl: "Avatar URL",
      testimonial: "Testimonial",
      role: "Role",
      photos: "photos",
      watch: "Watch",
      weeklySchedule: "Weekly schedule",
      seeEvents: "See events",
      joinUs: "Come join us",
      register: "Register",
      detailedProgram: "Detailed program",
      info: "Information",
      imageOptional: "Image (optional)",
      googleMaps: "Google Maps",
      sending: "Sending...",
      messageSent: "Message sent!",
      sendError: "An error occurred while sending",
      privacy: "Privacy",
      terms: "Terms",
      testimonials: "Life testimonies",
      testimonialsSubtitle: "Lives transformed by the grace of God within our community",
      upcoming: "Upcoming",
      past: "Past",
      noEvents: "No events in this category",
      noPhotos: "No photos in this folder",
      notFound: "not found",
      backTo: "Back to",
    },
    footer: {
      about: "About Emmaüs",
      aboutText: "Emmaüs is an evangelical Christian church that has been proclaiming Christ and building disciples for over 20 years.",
      serviceTimes: "Service times",
      sunday: "Sunday",
      wednesday: "Wednesday",
      contact: "Contact",
      rights: "All rights reserved",
    },
    about: {
      title: "About Emmaüs",
      subtitle: "Discover the history, vision and mission of our church",
      history: "Our history",
      historyText1: "Founded in 2004, Emmaüs Church was born from a simple yet profound vision: to create a place where everyone can meet God, grow in faith, and live in community. What started as a small prayer group in a living room has today become a family of several hundred people.",
      historyText2: "Over the years, Emmaüs has experienced remarkable growth, not only in number but above all in spiritual impact. We have seen lives transformed, families restored, and communities blessed by God's work.",
      historyText3: "Today, Emmaüs continues to be a beacon of hope in our city, welcoming visitors from all walks of life every week, united by the same faith and mission.",
      vision: "Our vision",
      mission: "Our mission",
      values: "Our values",
      pastor: "Our pastor",
      goals: "Spiritual goals",
      joinMission: "Join our mission",
      valuesList: {
        love: { title: "Love", desc: "We believe in God's unconditional love and seek to love others as Christ loved us." },
        word: { title: "Word of God", desc: "The Bible is our foundation. We study, teach, and apply the Word in all spheres of life." },
        community: { title: "Community", desc: "We are a family of faith where everyone finds their place, support, and spiritual growth." },
        service: { title: "Service", desc: "We serve our community with humility and compassion, bringing hope where it is needed." },
        mission: { title: "Mission", desc: "We are called to proclaim the Gospel in all nations and make disciples." },
        excellence: { title: "Excellence", desc: "We seek to honor God through excellence in everything we undertake." },
      },
      goalsList: [
        "Build fervent and committed disciples",
        "Proclaim the Gospel to our community",
        "Train quality spiritual leaders",
        "Impact society through concrete actions",
        "Support national and international missions",
      ],
      pastorBio1: "Pastor Jean Dupont has been serving the Lord for over 25 years. With a doctorate in theology and a heart passionate for souls, he founded Emmaüs with the vision of seeing a living and dynamic church.",
      pastorBio2: "His teaching is both deep and accessible, touching hundreds of lives each year. He firmly believes that every believer has a unique calling and extraordinary potential in Christ.",
      pastorBio3: "\"My greatest joy is seeing people discover their identity in Christ and walk in their destiny.\"",
    },
    contact: {
      title: "Contact us",
      subtitle: "We are here for you",
      info: "Contact information",
      form: "Send us a message",
      map: "Our location",
    },
    events: {
      subtitle: "Join us for moments of celebration, training, and fellowship",
      backToEvents: "Back to events",
      eventNotFound: "Event not found",
    },
    programs: {
      subtitle: "Discover our various programs and join us to grow together",
      ctaTitle: "Come join us",
      ctaSubtitle: "All our programs are open to everyone. Come as you are and let yourself be enriched by the community.",
    },
    communities: {
      subtitle: "Join a community where you can grow, share, and serve together",
      intro: "At Emmaüs, we believe that spiritual growth happens best in community. Each group offers a safe space to connect, study the Word, pray together, and support one another in faith.",
      notFound: "Can't find your community?",
      notFoundDesc: "Contact us and we will help you find the group that matches your season of life.",
    },
    videos: {
      subtitle: "Relive our sermons, teachings, and moments of praise",
      subscribeTitle: "Subscribe to our channel",
      subscribeDesc: "Don't miss any message. Get a notification for each new video published.",
    },
    gallery: {
      subtitle: "A look back in pictures at our moments of celebration and communion",
      backToGallery: "Back to gallery",
      folderNotFound: "Folder not found",
    },
    login: {
      adminSpace: "Admin space",
      email: "Email",
      password: "Password",
      loggingIn: "Logging in...",
      noAccount: "Don't have an account yet?",
      signUp: "Sign up",
      backToSite: "Back to site",
      loginError: "Login failed",
      forgotPassword: "Forgot password?",
      resetPassword: "Reset password",
      resetPasswordDesc: "Enter your email to receive a reset link.",
      resetPasswordSent: "Email sent! Check your inbox and spam folder.",
      sendResetLink: "Send link",
    },
    register: {
      createAccount: "Create admin account",
      accessAdmin: "Access the site administration area",
      emailAddress: "Email address",
      password: "Password",
      minChars: "Minimum 6 characters",
      confirmPassword: "Confirm password",
      creatingAccount: "Creating account...",
      createMyAccount: "Create my account",
      alreadyAccount: "Already have an account?",
      signIn: "Sign in",
      verifyEmail: "Verify your email",
      verifyEmailDesc: "A confirmation email has been sent to {email}. Click the link in the email to activate your account, then log in.",
      verifyEmailNote: "Note",
      verifyEmailSpam: "If you don't receive the email, check your spam. The link is valid for 24 hours.",
      goToLogin: "Go to login page",
      passwordMismatch: "Passwords do not match",
      passwordMinLength: "Password must be at least 6 characters",
      registerError: "Registration failed",
      backToSite: "Back to site",
    },
    admin: {
      dashboard: "Dashboard",
      messages: "Messages",
      events: "Events",
      programs: "Programs",
      communities: "Communities",
      gallery: "Gallery",
      videos: "Videos",
      users: "Users",
      testimonials: "Testimonials",
      settings: "Settings",
    },
    language: {
      fr: "French",
      en: "English",
      de: "German",
      zh: "Chinese",
      es: "Spanish",
      it: "Italian",
      pt: "Portuguese",
    },
  },
  de: {
    nav: {
      home: "Startseite",
      about: "Über uns",
      communities: "Gemeinschaften",
      programs: "Programme",
      events: "Veranstaltungen",
      gallery: "Galerie",
      videos: "Videos",
      contact: "Kontakt",
      admin: "Admin",
      login: "Anmelden",
      logout: "Abmelden",
    },
    hero: {
      welcome: "Willkommen bei Emmaüs",
      subtitle: "Eine Kirche, eine Familie, eine Mission",
      verse: "Denn wo zwei oder drei versammelt sind in meinem Namen, da bin ich mitten unter ihnen.",
      verseRef: "Matthäus 18:20",
      ctaPrimary: "Mitmachen",
      ctaSecondary: "Mehr erfahren",
    },
    sections: {
      programs: "Unsere Programme",
      events: "Kommende Veranstaltungen",
      videos: "Aktuelle Nachrichten",
      gallery: "Fotogalerie",
      pastor: "Pastoralbotschaft",
      communities: "Unsere Gemeinschaften",
    },
    common: {
      readMore: "Mehr lesen",
      viewAll: "Alle anzeigen",
      discover: "Entdecken",
      join: "Beitreten",
      contactUs: "Kontaktiere uns",
      send: "Senden",
      name: "Name",
      email: "Email",
      phone: "Telefon",
      subject: "Betreff",
      message: "Nachricht",
      address: "Adresse",
      followUs: "Folge uns",
      quickLinks: "Schnelllinks",
      language: "Sprache",
      newsletter: "Newsletter",
      subscribe: "Abonnieren",
      search: "Suchen",
      loading: "Wird geladen...",
      error: "Ein Fehler ist aufgetreten",
      success: "Vorgang erfolgreich",
      close: "Schließen",
      previous: "Zurück",
      next: "Weiter",
      add: "Hinzufügen",
      edit: "Bearbeiten",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      back: "Zurück",
      none: "Keine",
      confirm: "Bestätigen",
      all: "Alle",
      recent: "Neueste",
      justNow: "Gerade eben",
      minutesAgo: "min vor",
      hoursAgo: "h vor",
      daysAgo: "Tage vor",
      noSubject: "Kein Betreff",
      noLocation: "Ort nicht angegeben",
      title: "Titel",
      description: "Beschreibung",
      location: "Ort",
      date: "Datum",
      startTime: "Startzeit",
      endTime: "Endzeit",
      image: "Bild",
      category: "Kategorie",
      day: "Tag",
      leader: "Leiter",
      time: "Zeit",
      videoUrl: "Video URL",
      active: "Aktiv",
      inactive: "Inaktiv",
      visible: "sichtbar auf der Website",
      optional: "optional",
      choose: "Wählen",
      siteName: "Webseitenname",
      logoUrl: "Logo URL",
      primaryColor: "Hauptfarbe",
      secondaryColor: "Sekundärfarbe",
      footerText: "Footer-Text",
      program: "Programm",
      reply: "Antwort",
      welcome: "Willkommen in der Verwaltung",
      adminWelcome: "Verwenden Sie das linke Menü, um die Website-Inhalte zu verwalten. Kontaktnachrichten, Veranstaltungen, Programme, Gemeinschaften, Galerie und Videos können alle von ihren jeweiligen Seiten aus hinzugefügt, bearbeitet oder gelöscht werden.",
      preview: "Vorschau",
      carouselPreview: "Karussell-Vorschau",
      last30Days: "Letzte 30 Tage",
      messageEvolution: "Nachrichtenentwicklung",
      eventEvolution: "Veranstaltungsentwicklung",
      testimonialEvolution: "Zeugnisentwicklung",
      messageDistribution: "Nachrichtenverteilung",
      byStatus: "Nach Status",
      new: "Neu",
      replied: "Beantwortet",
      archived: "Archiviert",
      folder: "Ordner",
      coverImage: "Titelbild",
      avatarUrl: "Avatar URL",
      testimonial: "Zeugnis",
      role: "Rolle",
      photos: "Fotos",
      watch: "Ansehen",
      weeklySchedule: "Wochenplan",
      seeEvents: "Veranstaltungen ansehen",
      joinUs: "Kommen Sie zu uns",
      register: "Anmelden",
      detailedProgram: "Detailliertes Programm",
      info: "Informationen",
      imageOptional: "Bild (optional)",
      googleMaps: "Google Maps",
      sending: "Wird gesendet...",
      messageSent: "Nachricht gesendet!",
      sendError: "Beim Senden ist ein Fehler aufgetreten",
      privacy: "Datenschutz",
      terms: "Bedingungen",
      testimonials: "Lebenszeugnisse",
      testimonialsSubtitle: "Durch die Gnade Gottes verwandelte Leben in unserer Gemeinschaft",
      upcoming: "Kommend",
      past: "Vergangen",
      noEvents: "Keine Veranstaltungen in dieser Kategorie",
      noPhotos: "Keine Fotos in diesem Ordner",
      notFound: "nicht gefunden",
      backTo: "Zurück zu",
    },
    footer: {
      about: "Über Emmaüs",
      aboutText: "Emmaüs ist eine evangelikale christliche Kirche, die seit über 20 Jahren Christus verkündet und Jünger aufbaut.",
      serviceTimes: "Gottesdienstzeiten",
      sunday: "Sonntag",
      wednesday: "Mittwoch",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten",
    },
    about: {
      title: "Über Emmaüs",
      subtitle: "Entdecken Sie die Geschichte, Vision und Mission unserer Kirche",
      history: "Unsere Geschichte",
      historyText1: "Gegründet 2004, wurde die Emmaüs-Kirche aus einer einfachen, aber tiefen Vision geboren: einen Ort zu schaffen, an dem jeder Gott begegnen, im Glauben wachsen und in Gemeinschaft leben kann. Was als kleine Gebetsgruppe in einem Wohnzimmer begann, ist heute eine Familie von mehreren hundert Menschen geworden.",
      historyText2: "Im Laufe der Jahre hat Emmaüs ein bemerkenswertes Wachstum erlebt, nicht nur in der Anzahl, sondern vor allem in der spirituellen Wirkung. Wir haben verwandelte Leben, restaurierte Familien und gesegnete Gemeinschaften durch Gottes Werk gesehen.",
      historyText3: "Heute ist Emmaüs weiterhin ein Leuchtfeuer der Hoffnung in unserer Stadt und empfängt jede Woche Besucher aus allen Lebensbereichen, vereint durch den gleichen Glauben und die gleiche Mission.",
      vision: "Unsere Vision",
      mission: "Unsere Mission",
      values: "Unsere Werte",
      pastor: "Unser Pastor",
      goals: "Geistliche Ziele",
      joinMission: "Schließen Sie sich unserer Mission an",
      valuesList: {
        love: { title: "Liebe", desc: "Wir glauben an die bedingungslose Liebe Gottes und suchen danach, andere zu lieben, wie Christus uns geliebt hat." },
        word: { title: "Wort Gottes", desc: "Die Bibel ist unser Fundament. Wir studieren, lehren und wenden das Wort in allen Lebensbereichen an." },
        community: { title: "Gemeinschaft", desc: "Wir sind eine Glaubensfamilie, in der jeder seinen Platz, seine Unterstützung und sein spirituelles Wachstum findet." },
        service: { title: "Dienst", desc: "Wir dienen unserer Gemeinschaft mit Demut und Mitgefühl und bringen Hoffnung dorthin, wo sie gebraucht wird." },
        mission: { title: "Mission", desc: "Wir sind berufen, das Evangelium in allen Nationen zu verkünden und Jünger zu machen." },
        excellence: { title: "Exzellenz", desc: "Wir suchen danach, Gott durch Exzellenz in allem, was wir unternehmen, zu ehren." },
      },
      goalsList: [
        "Eifrige und engagierte Jünger aufbauen",
        "Das Evangelium in unserer Gemeinschaft verkünden",
        "Qualitativ hochwertige geistliche Führer ausbilden",
        "Die Gesellschaft durch konkrete Maßnahmen beeinflussen",
        "Nationale und internationale Missionen unterstützen",
      ],
      pastorBio1: "Pastor Jean Dupont dient dem Herrn seit mehr als 25 Jahren. Mit einem Doktortitel in Theologie und einem Herzen, das brennend für Seelen ist, gründete er Emmaüs mit der Vision, eine lebendige und dynamische Kirche zu sehen.",
      pastorBio2: "Seine Lehre ist sowohl tief als auch zugänglich und berührt jedes Jahr hunderte von Leben. Er glaubt fest daran, dass jeder Gläubige einen einzigartigen Beruf und ein außergewöhnliches Potential in Christus hat.",
      pastorBio3: "\"Meine größte Freude ist es, Menschen zu sehen, die ihre Identität in Christus entdecken und in ihre Bestimmung gehen.\"",
    },
    contact: {
      title: "Kontaktiere uns",
      subtitle: "Wir sind für dich da",
      info: "Kontaktinformationen",
      form: "Sende uns eine Nachricht",
      map: "Unser Standort",
    },
    events: {
      subtitle: "Schließen Sie sich uns an für Momente der Feier, Ausbildung und Gemeinschaft",
      backToEvents: "Zurück zu Veranstaltungen",
      eventNotFound: "Veranstaltung nicht gefunden",
    },
    programs: {
      subtitle: "Entdecken Sie unsere verschiedenen Programme und kommen Sie zu uns, um gemeinsam zu wachsen",
      ctaTitle: "Kommen Sie zu uns",
      ctaSubtitle: "Alle unsere Programme sind für alle offen. Kommen Sie, wie Sie sind, und lassen Sie sich von der Gemeinschaft bereichern.",
    },
    communities: {
      subtitle: "Treten Sie einer Gemeinschaft bei, in der Sie wachsen, teilen und gemeinsam dienen können",
      intro: "Bei Emmaüs glauben wir, dass geistliches Wachstum am besten in Gemeinschaft geschieht. Jede Gruppe bietet einen sicheren Raum, um sich zu verbinden, das Wort zu studieren, gemeinsam zu beten und sich gegenseitig im Glauben zu unterstützen.",
      notFound: "Finden Sie Ihre Gemeinschaft nicht?",
      notFoundDesc: "Kontaktieren Sie uns und wir helfen Ihnen, die Gruppe zu finden, die zu Ihrer Lebenssituation passt.",
    },
    videos: {
      subtitle: "Erleben Sie unsere Predigten, Lehren und Momente des Lobes erneut",
      subscribeTitle: "Abonnieren Sie unseren Kanal",
      subscribeDesc: "Verpassen Sie keine Botschaft. Erhalten Sie eine Benachrichtigung für jedes neue Video.",
    },
    gallery: {
      subtitle: "Ein Rückblick in Bildern auf unsere Momente der Feier und Gemeinschaft",
      backToGallery: "Zurück zur Galerie",
      folderNotFound: "Ordner nicht gefunden",
    },
    login: {
      adminSpace: "Verwaltungsbereich",
      email: "Email",
      password: "Passwort",
      loggingIn: "Anmeldung...",
      noAccount: "Noch kein Konto?",
      signUp: "Registrieren",
      backToSite: "Zurück zur Website",
      loginError: "Anmeldung fehlgeschlagen",
      forgotPassword: "Passwort vergessen?",
      resetPassword: "Passwort zurücksetzen",
      resetPasswordDesc: "Geben Sie Ihre Email ein, um einen Reset-Link zu erhalten.",
      resetPasswordSent: "Email gesendet! Überprüfen Sie Ihren Posteingang und Spam.",
      sendResetLink: "Link senden",
    },
    register: {
      createAccount: "Admin-Konto erstellen",
      accessAdmin: "Greifen Sie auf den Verwaltungsbereich der Website zu",
      emailAddress: "Email-Adresse",
      password: "Passwort",
      minChars: "Mindestens 6 Zeichen",
      confirmPassword: "Passwort bestätigen",
      creatingAccount: "Konto wird erstellt...",
      createMyAccount: "Mein Konto erstellen",
      alreadyAccount: "Bereits ein Konto?",
      signIn: "Anmelden",
      verifyEmail: "Überprüfen Sie Ihre Email",
      verifyEmailDesc: "Eine Bestätigungsmail wurde an {email} gesendet. Klicken Sie auf den Link in der Email, um Ihr Konto zu aktivieren, und melden Sie sich dann an.",
      verifyEmailNote: "Hinweis",
      verifyEmailSpam: "Wenn Sie die Email nicht erhalten, überprüfen Sie Ihren Spam-Ordner. Der Link ist 24 Stunden gültig.",
      goToLogin: "Zur Anmeldeseite",
      passwordMismatch: "Passwörter stimmen nicht überein",
      passwordMinLength: "Passwort muss mindestens 6 Zeichen enthalten",
      registerError: "Registrierung fehlgeschlagen",
      backToSite: "Zurück zur Website",
    },
    admin: {
      dashboard: "Dashboard",
      messages: "Nachrichten",
      events: "Veranstaltungen",
      programs: "Programme",
      communities: "Gemeinschaften",
      gallery: "Galerie",
      videos: "Videos",
      users: "Benutzer",
      testimonials: "Zeugnisse",
      settings: "Einstellungen",
    },
    language: {
      fr: "Französisch",
      en: "Englisch",
      de: "Deutsch",
      zh: "Chinesisch",
      es: "Spanisch",
      it: "Italienisch",
      pt: "Portugiesisch",
    },
  },
  zh: {
    nav: {
      home: "首页",
      about: "关于",
      communities: "社区",
      programs: "活动",
      events: "事件",
      gallery: "画廊",
      videos: "视频",
      contact: "联系",
      admin: "管理",
      login: "登录",
      logout: "退出",
    },
    hero: {
      welcome: "欢迎来到以马忤斯",
      subtitle: "一个教会，一个家庭，一个使命",
      verse: "因为无论在哪里，有两三个人奉我的名聚会，那里就有我在他们中间。",
      verseRef: "马太福音 18:20",
      ctaPrimary: "加入我们",
      ctaSecondary: "了解更多",
    },
    sections: {
      programs: "我们的活动",
      events: "即将举行的活动",
      videos: "最新信息",
      gallery: "照片画廊",
      pastor: "牧师信息",
      communities: "我们的社区",
    },
    common: {
      readMore: "阅读更多",
      viewAll: "查看全部",
      discover: "发现",
      join: "加入",
      contactUs: "联系我们",
      send: "发送",
      name: "姓名",
      email: "电子邮件",
      phone: "电话",
      subject: "主题",
      message: "信息",
      address: "地址",
      followUs: "关注我们",
      quickLinks: "快速链接",
      language: "语言",
      newsletter: "通讯",
      subscribe: "订阅",
      search: "搜索",
      loading: "加载中...",
      error: "发生错误",
      success: "操作成功",
      close: "关闭",
      previous: "上一页",
      next: "下一页",
      add: "添加",
      edit: "编辑",
      save: "保存",
      cancel: "取消",
      delete: "删除",
      back: "返回",
      none: "无",
      confirm: "确认",
      all: "全部",
      recent: "最近",
      justNow: "刚刚",
      minutesAgo: "分钟前",
      hoursAgo: "小时前",
      daysAgo: "天前",
      noSubject: "无主题",
      noLocation: "地点未指定",
      title: "标题",
      description: "描述",
      location: "地点",
      date: "日期",
      startTime: "开始时间",
      endTime: "结束时间",
      image: "图片",
      category: "类别",
      day: "日期",
      leader: "负责人",
      time: "时间",
      videoUrl: "视频链接",
      active: "活跃",
      inactive: "非活跃",
      visible: "在网站上可见",
      optional: "可选",
      choose: "选择",
      siteName: "网站名称",
      logoUrl: "Logo链接",
      primaryColor: "主色",
      secondaryColor: "副色",
      footerText: "页脚文字",
      program: "项目",
      reply: "回复",
      welcome: "欢迎进入管理后台",
      adminWelcome: "使用左侧菜单管理网站内容。联系消息、活动、项目、社区、图库和视频都可以从各自的页面添加、编辑或删除。",
      preview: "预览",
      carouselPreview: "轮播预览",
      last30Days: "最近30天",
      messageEvolution: "消息趋势",
      eventEvolution: "活动趋势",
      testimonialEvolution: "见证趋势",
      messageDistribution: "消息分布",
      byStatus: "按状态",
      new: "新",
      replied: "已回复",
      archived: "已归档",
      folder: "文件夹",
      coverImage: "封面图片",
      avatarUrl: "头像链接",
      testimonial: "见证",
      role: "角色",
      photos: "照片",
      watch: "观看",
      weeklySchedule: "每周日程",
      seeEvents: "查看活动",
      joinUs: "来加入我们",
      register: "注册",
      detailedProgram: "详细日程",
      info: "信息",
      imageOptional: "图片（可选）",
      googleMaps: "谷歌地图",
      sending: "发送中...",
      messageSent: "消息已发送！",
      sendError: "发送时发生错误",
      privacy: "隐私",
      terms: "条款",
      testimonials: "生命见证",
      testimonialsSubtitle: "在我们的社区中，被神的恩典改变的生命",
      upcoming: "即将到来",
      past: "过去",
      noEvents: "此类别中没有活动",
      noPhotos: "此文件夹中没有照片",
      notFound: "未找到",
      backTo: "返回",
    },
    footer: {
      about: "关于以马忤斯",
      aboutText: "以马忤斯是一个福音派基督教会，20多年来一直在宣扬基督并培养门徒。",
      serviceTimes: "崇拜时间",
      sunday: "星期日",
      wednesday: "星期三",
      contact: "联系",
      rights: "版权所有",
    },
    about: {
      title: "关于以马忤斯",
      subtitle: "了解我们教会的历史、愿景和使命",
      history: "我们的历史",
      historyText1: "以马忤斯教会成立于2004年，源于一个简单但深刻的愿景：创建一个让每个人都能遇见上帝、在信仰中成长并在社区中生活的地方。从客厅里的一个小祷告小组开始，今天已经发展成为数百人的大家庭。",
      historyText2: "多年来，以马忤斯经历了显著的增长，不仅在人数上，更在属灵影响上。我们看到生命被改变、家庭被恢复、社区被上帝的工作祝福。",
      historyText3: "今天，以马忤斯继续成为我们城市的希望灯塔，每周欢迎来自各行各业的访客，因相同的信仰和使命而团结。",
      vision: "我们的愿景",
      mission: "我们的使命",
      values: "我们的价值观",
      pastor: "我们的牧师",
      goals: "属灵目标",
      joinMission: "加入我们的使命",
      valuesList: {
        love: { title: "爱", desc: "我们相信上帝无条件的爱，并寻求像基督爱我们一样去爱他人。" },
        word: { title: "上帝的话语", desc: "圣经是我们的根基。我们在生活的各个领域学习、教导和应用话语。" },
        community: { title: "社区", desc: "我们是一个信仰家庭，每个人在这里找到自己的位置、支持和属灵成长。" },
        service: { title: "服侍", desc: "我们以谦卑和怜悯服侍我们的社区，将希望带到需要的地方。" },
        mission: { title: "使命", desc: "我们被呼召在万国中传扬福音，并使人作门徒。" },
        excellence: { title: "卓越", desc: "我们寻求在所做的一切事情中以卓越来荣耀上帝。" },
      },
      goalsList: [
        "建立热心和委身的门徒",
        "在我们的社区中传扬福音",
        "培养优质的属灵领袖",
        "通过具体行动影响社会",
        "支持国内和国际宣教",
      ],
      pastorBio1: "让·杜邦牧师已服侍主超过25年。凭借神学博士学位和对灵魂的热心，他创立了以马忤斯，愿景是看到一个活泼而充满活力的教会。",
      pastorBio2: "他的教导既深刻又平易近人，每年触动数百人的生命。他坚信每个信徒在基督里都有独特的呼召和非凡的潜力。",
      pastorBio3: "\"我最大的喜乐是看到人们在基督里发现他们的身份，并在他们的命定中行走。\"",
    },
    contact: {
      title: "联系我们",
      subtitle: "我们在这里为您服务",
      info: "联系信息",
      form: "给我们发送消息",
      map: "我们的位置",
    },
    events: {
      subtitle: "加入我们，共度庆祝、培训和团契的时刻",
      backToEvents: "返回活动",
      eventNotFound: "未找到活动",
    },
    programs: {
      subtitle: "发现我们的各种活动，加入我们共同成长",
      ctaTitle: "来加入我们",
      ctaSubtitle: "我们所有的活动对所有人开放。做你自己，让社区丰富你。",
    },
    communities: {
      subtitle: "加入一个社区，在那里你可以成长、分享和共同服侍",
      intro: "在以马忤斯，我们相信属灵成长最好在社区中发生。每个小组提供一个安全的空间来连接、学习话语、一起祷告并在信仰中相互支持。",
      notFound: "找不到您的社区？",
      notFoundDesc: "联系我们，我们将帮助您找到适合您人生阶段的群体。",
    },
    videos: {
      subtitle: "重温我们的讲道、教导和赞美的时刻",
      subscribeTitle: "订阅我们的频道",
      subscribeDesc: "不要错过任何消息。每次发布新视频时都会收到通知。",
    },
    gallery: {
      subtitle: "用图片回顾我们庆祝和团契的时刻",
      backToGallery: "返回画廊",
      folderNotFound: "未找到文件夹",
    },
    login: {
      adminSpace: "管理空间",
      email: "电子邮件",
      password: "密码",
      loggingIn: "登录中...",
      noAccount: "还没有账户？",
      signUp: "注册",
      backToSite: "返回网站",
      loginError: "登录失败",
      forgotPassword: "忘记密码？",
      resetPassword: "重置密码",
      resetPasswordDesc: "输入您的电子邮件以接收重置链接。",
      resetPasswordSent: "邮件已发送！请检查您的收件箱和垃圾邮件。",
      sendResetLink: "发送链接",
    },
    register: {
      createAccount: "创建管理员账户",
      accessAdmin: "访问网站管理区域",
      emailAddress: "电子邮件地址",
      password: "密码",
      minChars: "最少6个字符",
      confirmPassword: "确认密码",
      creatingAccount: "正在创建账户...",
      createMyAccount: "创建我的账户",
      alreadyAccount: "已有账户？",
      signIn: "登录",
      verifyEmail: "验证您的电子邮件",
      verifyEmailDesc: "确认邮件已发送至 {email}。点击邮件中的链接激活您的账户，然后登录。",
      verifyEmailNote: "注意",
      verifyEmailSpam: "如果您没有收到邮件，请检查垃圾邮件。链接有效期为24小时。",
      goToLogin: "前往登录页面",
      passwordMismatch: "密码不匹配",
      passwordMinLength: "密码必须至少包含6个字符",
      registerError: "注册失败",
      backToSite: "返回网站",
    },
    admin: {
      dashboard: "仪表板",
      messages: "消息",
      events: "事件",
      programs: "活动",
      communities: "社区",
      gallery: "画廊",
      videos: "视频",
      users: "用户",
      testimonials: "见证",
      settings: "设置",
    },
    language: {
      fr: "法语",
      en: "英语",
      de: "德语",
      zh: "中文",
      es: "西班牙语",
      it: "意大利语",
      pt: "葡萄牙语",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      communities: "Comunidades",
      programs: "Programas",
      events: "Eventos",
      gallery: "Galería",
      videos: "Videos",
      contact: "Contacto",
      admin: "Admin",
      login: "Iniciar sesión",
      logout: "Cerrar sesión",
    },
    hero: {
      welcome: "Bienvenido a Emaús",
      subtitle: "Una iglesia, una familia, una misión",
      verse: "Porque donde están dos o tres congregados en mi nombre, allí estoy yo en medio de ellos.",
      verseRef: "Mateo 18:20",
      ctaPrimary: "Únete",
      ctaSecondary: "Saber más",
    },
    sections: {
      programs: "Nuestros Programas",
      events: "Próximos eventos",
      videos: "Mensajes recientes",
      gallery: "Galería de fotos",
      pastor: "Mensaje pastoral",
      communities: "Nuestras comunidades",
    },
    common: {
      readMore: "Leer más",
      viewAll: "Ver todo",
      discover: "Descubrir",
      join: "Unirse",
      contactUs: "Contáctanos",
      send: "Enviar",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono",
      subject: "Asunto",
      message: "Mensaje",
      address: "Dirección",
      followUs: "Síguenos",
      quickLinks: "Enlaces rápidos",
      language: "Idioma",
      newsletter: "Boletín",
      subscribe: "Suscribirse",
      search: "Buscar",
      loading: "Cargando...",
      error: "Ha ocurrido un error",
      success: "Operación exitosa",
      close: "Cerrar",
      previous: "Anterior",
      next: "Siguiente",
      add: "Agregar",
      edit: "Editar",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      back: "Volver",
      none: "Ninguno",
      confirm: "Confirmar",
      all: "Todos",
      recent: "Recientes",
      justNow: "Ahora mismo",
      minutesAgo: "min atrás",
      hoursAgo: "h atrás",
      daysAgo: "días atrás",
      noSubject: "Sin asunto",
      noLocation: "Ubicación no especificada",
      title: "Título",
      description: "Descripción",
      location: "Ubicación",
      date: "Fecha",
      startTime: "Hora de inicio",
      endTime: "Hora de fin",
      image: "Imagen",
      category: "Categoría",
      day: "Día",
      leader: "Responsable",
      time: "Hora",
      videoUrl: "URL del video",
      active: "Activo",
      inactive: "Inactivo",
      visible: "visible en el sitio",
      optional: "opcional",
      choose: "Elegir",
      siteName: "Nombre del sitio",
      logoUrl: "URL del logo",
      primaryColor: "Color principal",
      secondaryColor: "Color secundario",
      footerText: "Texto del footer",
      program: "Programa",
      reply: "Respuesta",
      welcome: "Bienvenido a la administración",
      adminWelcome: "Use el menú de la izquierda para gestionar el contenido del sitio. Los mensajes de contacto, eventos, programas, comunidades, galería y videos pueden agregarse, editarse o eliminarse desde sus respectivas páginas.",
      preview: "Vista previa",
      carouselPreview: "Vista previa del carrusel",
      last30Days: "Últimos 30 días",
      messageEvolution: "Evolución de mensajes",
      eventEvolution: "Evolución de eventos",
      testimonialEvolution: "Evolución de testimonios",
      messageDistribution: "Distribución de mensajes",
      byStatus: "Por estado",
      new: "Nuevos",
      replied: "Respondidos",
      archived: "Archivados",
      folder: "Carpeta",
      coverImage: "Imagen de portada",
      avatarUrl: "URL del avatar",
      testimonial: "Testimonio",
      role: "Rol",
      photos: "fotos",
      watch: "Ver",
      weeklySchedule: "Horario semanal",
      seeEvents: "Ver eventos",
      joinUs: "Ven y únete",
      register: "Inscribirse",
      detailedProgram: "Programa detallado",
      info: "Información",
      imageOptional: "Imagen (opcional)",
      googleMaps: "Google Maps",
      sending: "Enviando...",
      messageSent: "¡Mensaje enviado!",
      sendError: "Ocurrió un error al enviar",
      privacy: "Privacidad",
      terms: "Términos",
      testimonials: "Testimonios de vida",
      testimonialsSubtitle: "Vidas transformadas por la gracia de Dios dentro de nuestra comunidad",
      upcoming: "Próximos",
      past: "Pasados",
      noEvents: "No hay eventos en esta categoría",
      noPhotos: "No hay fotos en esta carpeta",
      notFound: "no encontrado",
      backTo: "Volver a",
    },
    footer: {
      about: "Sobre Emaús",
      aboutText: "Emaús es una iglesia cristiana evangélica que proclama a Cristo y edifica discípulos desde hace más de 20 años.",
      serviceTimes: "Horarios de culto",
      sunday: "Domingo",
      wednesday: "Miércoles",
      contact: "Contacto",
      rights: "Todos los derechos reservados",
    },
    about: {
      title: "Sobre Emaús",
      subtitle: "Descubre la historia, visión y misión de nuestra iglesia",
      history: "Nuestra historia",
      historyText1: "Fundada en 2004, la Iglesia Emaús nació de una visión simple pero profunda: crear un lugar donde cada uno pueda encontrar a Dios, crecer en fe y vivir en comunidad. Lo que comenzó como un pequeño grupo de oración en una sala de estar se ha convertido hoy en una familia de varios cientos de personas.",
      historyText2: "A lo largo de los años, Emaús ha experimentado un crecimiento notable, no solo en número, sino sobre todo en impacto espiritual. Hemos visto vidas transformadas, familias restauradas y comunidades bendecidas por la obra de Dios.",
      historyText3: "Hoy, Emaús continúa siendo un faro de esperanza en nuestra ciudad, dando la bienvenida cada semana a visitantes de todos los ámbitos, unidos por la misma fe y misión.",
      vision: "Nuestra visión",
      mission: "Nuestra misión",
      values: "Nuestros valores",
      pastor: "Nuestro pastor",
      goals: "Objetivos espirituales",
      joinMission: "Únete a nuestra misión",
      valuesList: {
        love: { title: "Amor", desc: "Creemos en el amor incondicional de Dios y buscamos amar a los demás como Cristo nos amó." },
        word: { title: "Palabra de Dios", desc: "La Biblia es nuestro fundamento. Estudiamos, enseñamos y aplicamos la Palabra en todas las esferas de la vida." },
        community: { title: "Comunidad", desc: "Somos una familia de fe donde cada uno encuentra su lugar, su apoyo y su crecimiento espiritual." },
        service: { title: "Servicio", desc: "Servimos a nuestra comunidad con humildad y compasión, llevando esperanza donde se necesita." },
        mission: { title: "Misión", desc: "Estamos llamados a proclamar el Evangelio en todas las naciones y a hacer discípulos." },
        excellence: { title: "Excelencia", desc: "Buscamos honrar a Dios mediante la excelencia en todo lo que emprendemos." },
      },
      goalsList: [
        "Edificar discípulos fervientes y comprometidos",
        "Proclamar el Evangelio a nuestra comunidad",
        "Formar líderes espirituales de calidad",
        "Impactar la sociedad a través de acciones concretas",
        "Apoyar las misiones nacionales e internacionales",
      ],
      pastorBio1: "El Pastor Jean Dupont ha servido al Señor durante más de 25 años. Con un doctorado en teología y un corazón apasionado por las almas, fundó Emaús con la visión de ver una iglesia viva y dinámica.",
      pastorBio2: "Su enseñanza es a la vez profunda y accesible, tocando cientos de vidas cada año. Cree firmemente que cada creyente tiene un llamado único y un potencial extraordinario en Cristo.",
      pastorBio3: "\"Mi mayor alegría es ver personas descubrir su identidad en Cristo y caminar en su destino.\"",
    },
    contact: {
      title: "Contáctanos",
      subtitle: "Estamos aquí para ti",
      info: "Información de contacto",
      form: "Envíanos un mensaje",
      map: "Nuestra ubicación",
    },
    events: {
      subtitle: "Únete a nosotros para momentos de celebración, formación y comunión",
      backToEvents: "Volver a eventos",
      eventNotFound: "Evento no encontrado",
    },
    programs: {
      subtitle: "Descubre nuestros diversos programas y únete a nosotros para crecer juntos",
      ctaTitle: "Ven y únete",
      ctaSubtitle: "Todos nuestros programas están abiertos a todos. Ven como eres y déjate enriquecer por la comunidad.",
    },
    communities: {
      subtitle: "Únete a una comunidad donde puedas crecer, compartir y servir juntos",
      intro: "En Emaús, creemos que el crecimiento espiritual ocurre mejor en comunidad. Cada grupo ofrece un espacio seguro para conectarse, estudiar la Palabra, orar juntos y apoyarse mutuamente en la fe.",
      notFound: "¿No encuentras tu comunidad?",
      notFoundDesc: "Contáctanos y te ayudaremos a encontrar el grupo que corresponda a tu temporada de vida.",
    },
    videos: {
      subtitle: "Revive nuestros sermones, enseñanzas y momentos de alabanza",
      subscribeTitle: "Suscríbete a nuestro canal",
      subscribeDesc: "No te pierdas ningún mensaje. Recibe una notificación por cada nuevo video publicado.",
    },
    gallery: {
      subtitle: "Un vistazo en imágenes a nuestros momentos de celebración y comunión",
      backToGallery: "Volver a la galería",
      folderNotFound: "Carpeta no encontrada",
    },
    login: {
      adminSpace: "Espacio de administración",
      email: "Email",
      password: "Contraseña",
      loggingIn: "Iniciando sesión...",
      noAccount: "¿Aún no tienes cuenta?",
      signUp: "Registrarse",
      backToSite: "Volver al sitio",
      loginError: "Error de inicio de sesión",
      forgotPassword: "¿Olvidaste tu contraseña?",
      resetPassword: "Restablecer contraseña",
      resetPasswordDesc: "Ingresa tu email para recibir un enlace de restablecimiento.",
      resetPasswordSent: "¡Email enviado! Revisa tu bandeja de entrada y spam.",
      sendResetLink: "Enviar enlace",
    },
    register: {
      createAccount: "Crear cuenta de administrador",
      accessAdmin: "Accede al área de administración del sitio",
      emailAddress: "Dirección de email",
      password: "Contraseña",
      minChars: "Mínimo 6 caracteres",
      confirmPassword: "Confirmar contraseña",
      creatingAccount: "Creando cuenta...",
      createMyAccount: "Crear mi cuenta",
      alreadyAccount: "¿Ya tienes cuenta?",
      signIn: "Iniciar sesión",
      verifyEmail: "Verifica tu email",
      verifyEmailDesc: "Se ha enviado un email de confirmación a {email}. Haz clic en el enlace del email para activar tu cuenta, luego inicia sesión.",
      verifyEmailNote: "Nota",
      verifyEmailSpam: "Si no recibes el email, verifica tu spam. El enlace es válido por 24 horas.",
      goToLogin: "Ir a la página de inicio de sesión",
      passwordMismatch: "Las contraseñas no coinciden",
      passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
      registerError: "Error de registro",
      backToSite: "Volver al sitio",
    },
    admin: {
      dashboard: "Panel",
      messages: "Mensajes",
      events: "Eventos",
      programs: "Programas",
      communities: "Comunidades",
      gallery: "Galería",
      videos: "Videos",
      users: "Usuarios",
      testimonials: "Testimonios",
      settings: "Configuración",
    },
    language: {
      fr: "Francés",
      en: "Inglés",
      de: "Alemán",
      zh: "Chino",
      es: "Español",
      it: "Italiano",
      pt: "Portugués",
    },
  },
  it: {
    nav: {
      home: "Home",
      about: "Chi siamo",
      communities: "Comunità",
      programs: "Programmi",
      events: "Eventi",
      gallery: "Galleria",
      videos: "Video",
      contact: "Contatto",
      admin: "Admin",
      login: "Accedi",
      logout: "Esci",
    },
    hero: {
      welcome: "Benvenuto a Emmaus",
      subtitle: "Una chiesa, una famiglia, una missione",
      verse: "Perché dove sono due o tre riuniti nel mio nome, io sono in mezzo a loro.",
      verseRef: "Matteo 18:20",
      ctaPrimary: "Unisciti",
      ctaSecondary: "Scopri di più",
    },
    sections: {
      programs: "I nostri programmi",
      events: "Prossimi eventi",
      videos: "Messaggi recenti",
      gallery: "Galleria foto",
      pastor: "Messaggio pastorale",
      communities: "Le nostre comunità",
    },
    common: {
      readMore: "Leggi di più",
      viewAll: "Vedi tutto",
      discover: "Scopri",
      join: "Unisciti",
      contactUs: "Contattaci",
      send: "Invia",
      name: "Nome",
      email: "Email",
      phone: "Telefono",
      subject: "Oggetto",
      message: "Messaggio",
      address: "Indirizzo",
      followUs: "Seguici",
      quickLinks: "Link rapidi",
      language: "Lingua",
      newsletter: "Newsletter",
      subscribe: "Iscriviti",
      search: "Cerca",
      loading: "Caricamento...",
      error: "Si è verificato un errore",
      success: "Operazione riuscita",
      close: "Chiudi",
      previous: "Precedente",
      next: "Successivo",
      add: "Aggiungi",
      edit: "Modifica",
      save: "Salva",
      cancel: "Annulla",
      delete: "Elimina",
      back: "Indietro",
      none: "Nessuno",
      confirm: "Conferma",
      all: "Tutti",
      recent: "Recenti",
      justNow: "Proprio ora",
      minutesAgo: "min fa",
      hoursAgo: "h fa",
      daysAgo: "giorni fa",
      noSubject: "Nessun oggetto",
      noLocation: "Luogo non specificato",
      title: "Titolo",
      description: "Descrizione",
      location: "Luogo",
      date: "Data",
      startTime: "Ora inizio",
      endTime: "Ora fine",
      image: "Immagine",
      category: "Categoria",
      day: "Giorno",
      leader: "Responsabile",
      time: "Ora",
      videoUrl: "URL del video",
      active: "Attivo",
      inactive: "Inattivo",
      visible: "visibile sul sito",
      optional: "opzionale",
      choose: "Scegli",
      siteName: "Nome del sito",
      logoUrl: "URL del logo",
      primaryColor: "Colore principale",
      secondaryColor: "Colore secondario",
      footerText: "Testo del footer",
      program: "Programma",
      reply: "Risposta",
      welcome: "Benvenuto nell'amministrazione",
      adminWelcome: "Usa il menu a sinistra per gestire i contenuti del sito. I messaggi di contatto, eventi, programmi, comunità, galleria e video possono essere aggiunti, modificati o eliminati dalle rispettive pagine.",
      preview: "Anteprima",
      carouselPreview: "Anteprima carosello",
      last30Days: "Ultimi 30 giorni",
      messageEvolution: "Evoluzione messaggi",
      eventEvolution: "Evoluzione eventi",
      testimonialEvolution: "Evoluzione testimonianze",
      messageDistribution: "Distribuzione messaggi",
      byStatus: "Per stato",
      new: "Nuovi",
      replied: "Risposti",
      archived: "Archiviati",
      folder: "Cartella",
      coverImage: "Immagine di copertina",
      avatarUrl: "URL avatar",
      testimonial: "Testimonianza",
      role: "Ruolo",
      photos: "foto",
      watch: "Guarda",
      weeklySchedule: "Programma settimanale",
      seeEvents: "Vedi eventi",
      joinUs: "Vieni a unirti",
      register: "Iscriviti",
      detailedProgram: "Programma dettagliato",
      info: "Informazioni",
      imageOptional: "Immagine (opzionale)",
      googleMaps: "Google Maps",
      sending: "Invio in corso...",
      messageSent: "Messaggio inviato!",
      sendError: "Si è verificato un errore durante l'invio",
      privacy: "Privacy",
      terms: "Termini",
      testimonials: "Testimonianze di vita",
      testimonialsSubtitle: "Vite trasformate dalla grazia di Dio all'interno della nostra comunità",
      upcoming: "In arrivo",
      past: "Passati",
      noEvents: "Nessun evento in questa categoria",
      noPhotos: "Nessuna foto in questa cartella",
      notFound: "non trovato",
      backTo: "Torna ai",
    },
    footer: {
      about: "Su Emmaus",
      aboutText: "Emmaus è una chiesa cristiana evangelica che proclama Cristo ed edifica discepoli da oltre 20 anni.",
      serviceTimes: "Orari del culto",
      sunday: "Domenica",
      wednesday: "Mercoledì",
      contact: "Contatto",
      rights: "Tutti i diritti riservati",
    },
    about: {
      title: "Chi siamo",
      subtitle: "Scopri la storia, la visione e la missione della nostra chiesa",
      history: "La nostra storia",
      historyText1: "Fondata nel 2004, la Chiesa Emmaus è nata da una visione semplice ma profonda: creare un luogo dove ognuno può incontrare Dio, crescere nella fede e vivere in comunità. Ciò che è iniziato come un piccolo gruppo di preghiera in un soggiorno è oggi diventato una famiglia di diverse centinaia di persone.",
      historyText2: "Nel corso degli anni, Emmaus ha conosciuto una crescita notevole, non solo in numero ma soprattutto in impatto spirituale. Abbiamo visto vite trasformate, famiglie restaurate e comunità benedette dall'opera di Dio.",
      historyText3: "Oggi, Emmaus continua a essere un faro di speranza nella nostra città, accogliendo ogni settimana visitatori di ogni estrazione sociale, uniti dalla stessa fede e missione.",
      vision: "La nostra visione",
      mission: "La nostra missione",
      values: "I nostri valori",
      pastor: "Il nostro pastore",
      goals: "Obiettivi spirituali",
      joinMission: "Unisciti alla nostra missione",
      valuesList: {
        love: { title: "Amore", desc: "Crediamo nell'amore incondizionato di Dio e cerchiamo di amare gli altri come Cristo ci ha amati." },
        word: { title: "Parola di Dio", desc: "La Bibbia è il nostro fondamento. Studiamo, insegniamo e applichiamo la Parola in tutte le sfere della vita." },
        community: { title: "Comunità", desc: "Siamo una famiglia di fede dove ognuno trova il proprio posto, il proprio sostegno e la propria crescita spirituale." },
        service: { title: "Servizio", desc: "Serviamo la nostra comunità con umiltà e compassione, portando la speranza dove è necessaria." },
        mission: { title: "Missione", desc: "Siamo chiamati a proclamare il Vangelo in tutte le nazioni e a fare discepoli." },
        excellence: { title: "Eccellenza", desc: "Cerchiamo di onorare Dio attraverso l'eccellenza in tutto ciò che intraprendiamo." },
      },
      goalsList: [
        "Edificare discepoli ferventi e impegnati",
        "Proclamare il Vangelo alla nostra comunità",
        "Formare leader spirituali di qualità",
        "Impatto sulla società attraverso azioni concrete",
        "Sostenere le missioni nazionali e internazionali",
      ],
      pastorBio1: "Il Pastore Jean Dupont serve il Signore da oltre 25 anni. Con un dottorato in teologia e un cuore appassionato per le anime, ha fondato Emmaus con la visione di vedere una chiesa viva e dinamica.",
      pastorBio2: "Il suo insegnamento è allo stesso tempo profondo e accessibile, toccando centinaia di vite ogni anno. Crede fermamente che ogni credente abbia una chiamata unica e un potenziale straordinario in Cristo.",
      pastorBio3: "\"La mia più grande gioia è vedere persone scoprire la loro identità in Cristo e camminare nel loro destino.\"",
    },
    contact: {
      title: "Contattaci",
      subtitle: "Siamo qui per te",
      info: "Informazioni di contatto",
      form: "Inviaci un messaggio",
      map: "La nostra posizione",
    },
    events: {
      subtitle: "Unisciti a noi per momenti di celebrazione, formazione e comunione",
      backToEvents: "Torna agli eventi",
      eventNotFound: "Evento non trovato",
    },
    programs: {
      subtitle: "Scopri i nostri vari programmi e unisciti a noi per crescere insieme",
      ctaTitle: "Vieni a unirti",
      ctaSubtitle: "Tutti i nostri programmi sono aperti a tutti. Vieni come sei e lasciati arricchire dalla comunità.",
    },
    communities: {
      subtitle: "Unisciti a una comunità dove puoi crescere, condividere e servire insieme",
      intro: "Ad Emmaus, crediamo che la crescita spirituale avvenga al meglio in comunità. Ogni gruppo offre uno spazio sicuro per connettersi, studiare la Parola, pregare insieme e sostenersi a vicenda nella fede.",
      notFound: "Non trovi la tua comunità?",
      notFoundDesc: "Contattaci e ti aiuteremo a trovare il gruppo che corrisponde alla tua stagione di vita.",
    },
    videos: {
      subtitle: "Rivivi i nostri sermoni, insegnamenti e momenti di lode",
      subscribeTitle: "Iscriviti al nostro canale",
      subscribeDesc: "Non perdere nessun messaggio. Ricevi una notifica per ogni nuovo video pubblicato.",
    },
    gallery: {
      subtitle: "Uno sguardo in immagini ai nostri momenti di celebrazione e comunione",
      backToGallery: "Torna alla galleria",
      folderNotFound: "Cartella non trovata",
    },
    login: {
      adminSpace: "Spazio amministrativo",
      email: "Email",
      password: "Password",
      loggingIn: "Accesso in corso...",
      noAccount: "Non hai ancora un account?",
      signUp: "Registrati",
      backToSite: "Torna al sito",
      loginError: "Accesso fallito",
      forgotPassword: "Password dimenticata?",
      resetPassword: "Reimposta password",
      resetPasswordDesc: "Inserisci la tua email per ricevere un link di reimpostazione.",
      resetPasswordSent: "Email inviata! Controlla la tua casella di posta e spam.",
      sendResetLink: "Invia link",
    },
    register: {
      createAccount: "Crea account amministratore",
      accessAdmin: "Accedi all'area di amministrazione del sito",
      emailAddress: "Indirizzo email",
      password: "Password",
      minChars: "Minimo 6 caratteri",
      confirmPassword: "Conferma password",
      creatingAccount: "Creazione account in corso...",
      createMyAccount: "Crea il mio account",
      alreadyAccount: "Hai già un account?",
      signIn: "Accedi",
      verifyEmail: "Verifica la tua email",
      verifyEmailDesc: "Un'email di conferma è stata inviata a {email}. Clicca sul link nell'email per attivare il tuo account, poi accedi.",
      verifyEmailNote: "Nota",
      verifyEmailSpam: "Se non ricevi l'email, controlla la spam. Il link è valido per 24 ore.",
      goToLogin: "Vai alla pagina di accesso",
      passwordMismatch: "Le password non corrispondono",
      passwordMinLength: "La password deve contenere almeno 6 caratteri",
      registerError: "Registrazione fallita",
      backToSite: "Torna al sito",
    },
    admin: {
      dashboard: "Dashboard",
      messages: "Messaggi",
      events: "Eventi",
      programs: "Programmi",
      communities: "Comunità",
      gallery: "Galleria",
      videos: "Video",
      users: "Utenti",
      testimonials: "Testimonianze",
      settings: "Impostazioni",
    },
    language: {
      fr: "Francese",
      en: "Inglese",
      de: "Tedesco",
      zh: "Cinese",
      es: "Spagnolo",
      it: "Italiano",
      pt: "Portoghese",
    },
  },
  pt: {
    nav: {
      home: "Início",
      about: "Sobre",
      communities: "Comunidades",
      programs: "Programas",
      events: "Eventos",
      gallery: "Galeria",
      videos: "Vídeos",
      contact: "Contato",
      admin: "Admin",
      login: "Entrar",
      logout: "Sair",
    },
    hero: {
      welcome: "Bem-vindo a Emaús",
      subtitle: "Uma igreja, uma família, uma missão",
      verse: "Porque onde estiverem dois ou três reunidos em meu nome, aí estou eu no meio deles.",
      verseRef: "Mateus 18:20",
      ctaPrimary: "Junte-se",
      ctaSecondary: "Saiba mais",
    },
    sections: {
      programs: "Nossos programas",
      events: "Próximos eventos",
      videos: "Mensagens recentes",
      gallery: "Galeria de fotos",
      pastor: "Mensagem pastoral",
      communities: "Nossas comunidades",
    },
    common: {
      readMore: "Leia mais",
      viewAll: "Ver tudo",
      discover: "Descubrir",
      join: "Juntar-se",
      contactUs: "Contate-nos",
      send: "Enviar",
      name: "Nome",
      email: "Email",
      phone: "Telefone",
      subject: "Assunto",
      message: "Mensagem",
      address: "Endereço",
      followUs: "Siga-nos",
      quickLinks: "Links rápidos",
      language: "Idioma",
      newsletter: "Boletim",
      subscribe: "Inscrever-se",
      search: "Pesquisar",
      loading: "Carregando...",
      error: "Ocorreu um erro",
      success: "Operação bem-sucedida",
      close: "Fechar",
      previous: "Anterior",
      next: "Próximo",
      add: "Adicionar",
      edit: "Editar",
      save: "Salvar",
      cancel: "Cancelar",
      delete: "Excluir",
      back: "Voltar",
      none: "Nenhum",
      confirm: "Confirmar",
      all: "Todos",
      recent: "Recentes",
      justNow: "Agora mesmo",
      minutesAgo: "min atrás",
      hoursAgo: "h atrás",
      daysAgo: "dias atrás",
      noSubject: "Sem assunto",
      noLocation: "Local não especificado",
      title: "Título",
      description: "Descrição",
      location: "Localização",
      date: "Data",
      startTime: "Hora de início",
      endTime: "Hora de término",
      image: "Imagem",
      category: "Categoria",
      day: "Dia",
      leader: "Responsável",
      time: "Hora",
      videoUrl: "URL do vídeo",
      active: "Ativo",
      inactive: "Inativo",
      visible: "visível no site",
      optional: "opcional",
      choose: "Escolher",
      siteName: "Nome do site",
      logoUrl: "URL do logo",
      primaryColor: "Cor principal",
      secondaryColor: "Cor secundária",
      footerText: "Texto do footer",
      program: "Programa",
      reply: "Resposta",
      welcome: "Bem-vindo à administração",
      adminWelcome: "Use o menu à esquerda para gerenciar o conteúdo do site. As mensagens de contato, eventos, programas, comunidades, galeria e vídeos podem ser adicionados, editados ou excluídos de suas respectivas páginas.",
      preview: "Pré-visualização",
      carouselPreview: "Pré-visualização do carrossel",
      last30Days: "Últimos 30 dias",
      messageEvolution: "Evolução de mensagens",
      eventEvolution: "Evolução de eventos",
      testimonialEvolution: "Evolução de testemunhos",
      messageDistribution: "Distribuição de mensagens",
      byStatus: "Por status",
      new: "Novos",
      replied: "Respondidos",
      archived: "Arquivados",
      folder: "Pasta",
      coverImage: "Imagem de capa",
      avatarUrl: "URL do avatar",
      testimonial: "Testemunho",
      role: "Papel",
      photos: "fotos",
      watch: "Assistir",
      weeklySchedule: "Agenda semanal",
      seeEvents: "Ver eventos",
      joinUs: "Venha se juntar",
      register: "Inscrever-se",
      detailedProgram: "Programa detalhado",
      info: "Informações",
      imageOptional: "Imagem (opcional)",
      googleMaps: "Google Maps",
      sending: "Enviando...",
      messageSent: "Mensagem enviada!",
      sendError: "Ocorreu um erro ao enviar",
      privacy: "Privacidade",
      terms: "Termos",
      testimonials: "Testemunhos de vida",
      testimonialsSubtitle: "Vidas transformadas pela graça de Deus dentro da nossa comunidade",
      upcoming: "Próximos",
      past: "Passados",
      noEvents: "Nenhum evento nesta categoria",
      noPhotos: "Nenhuma foto nesta pasta",
      notFound: "não encontrado",
      backTo: "Voltar aos",
    },
    footer: {
      about: "Sobre Emaús",
      aboutText: "Emaús é uma igreja cristã evangélica que proclama Cristo e edifica discípulos há mais de 20 anos.",
      serviceTimes: "Horários do culto",
      sunday: "Domingo",
      wednesday: "Quarta-feira",
      contact: "Contato",
      rights: "Todos os direitos reservados",
    },
    about: {
      title: "Sobre Emaús",
      subtitle: "Descubra a história, visão e missão da nossa igreja",
      history: "Nossa história",
      historyText1: "Fundada em 2004, a Igreja Emaús nasceu de uma visão simples mas profunda: criar um lugar onde cada um possa encontrar Deus, crescer na fé e viver em comunidade. O que começou como um pequeno grupo de oração numa sala de estar tornou-se hoje uma família de várias centenas de pessoas.",
      historyText2: "Ao longo dos anos, Emaús experimentou um crescimento notável, não apenas em número, mas sobretudo em impacto espiritual. Vimos vidas transformadas, famílias restauradas e comunidades abençoadas pela obra de Deus.",
      historyText3: "Hoje, Emaús continua a ser um farol de esperança na nossa cidade, acolhendo todas as semanas visitantes de todos os horizontes, unidos pela mesma fé e missão.",
      vision: "Nossa visão",
      mission: "Nossa missão",
      values: "Nossos valores",
      pastor: "Nosso pastor",
      goals: "Objetivos espirituais",
      joinMission: "Junte-se à nossa missão",
      valuesList: {
        love: { title: "Amor", desc: "Acreditamos no amor incondicional de Deus e buscamos amar os outros como Cristo nos amou." },
        word: { title: "Palavra de Deus", desc: "A Bíblia é o nosso fundamento. Estudamos, ensinamos e aplicamos a Palavra em todas as esferas da vida." },
        community: { title: "Comunidade", desc: "Somos uma família de fé onde cada um encontra o seu lugar, o seu apoio e o seu crescimento espiritual." },
        service: { title: "Serviço", desc: "Servimos a nossa comunidade com humildade e compaixão, levando esperança onde é necessária." },
        mission: { title: "Missão", desc: "Somos chamados a proclamar o Evangelho em todas as nações e a fazer discípulos." },
        excellence: { title: "Excelência", desc: "Buscamos honrar a Deus através da excelência em tudo o que empreendemos." },
      },
      goalsList: [
        "Edificar discípulos fervorosos e comprometidos",
        "Proclamar o Evangelho à nossa comunidade",
        "Formar líderes espirituais de qualidade",
        "Impactar a sociedade através de ações concretas",
        "Apoiar missões nacionais e internacionais",
      ],
      pastorBio1: "O Pastor Jean Dupont serve o Senhor há mais de 25 anos. Com um doutorado em teologia e um coração apaixonado pelas almas, fundou Emaús com a visão de ver uma igreja viva e dinâmica.",
      pastorBio2: "O seu ensino é ao mesmo tempo profundo e acessível, tocando centenas de vidas todos os anos. Acredita firmemente que cada crente tem um chamado único e um potencial extraordinário em Cristo.",
      pastorBio3: "\"A minha maior alegria é ver pessoas descobrirem a sua identidade em Cristo e caminharem no seu destino.\"",
    },
    contact: {
      title: "Contate-nos",
      subtitle: "Estamos aqui para você",
      info: "Informações de contato",
      form: "Envie-nos uma mensagem",
      map: "Nossa localização",
    },
    events: {
      subtitle: "Junte-se a nós para momentos de celebração, formação e comunhão",
      backToEvents: "Voltar aos eventos",
      eventNotFound: "Evento não encontrado",
    },
    programs: {
      subtitle: "Descubra os nossos vários programas e junte-se a nós para crescer juntos",
      ctaTitle: "Venha juntar-se a nós",
      ctaSubtitle: "Todos os nossos programas são abertos a todos. Venha como você é e deixe-se enriquecer pela comunidade.",
    },
    communities: {
      subtitle: "Junte-se a uma comunidade onde pode crescer, partilhar e servir juntos",
      intro: "Em Emaús, acreditamos que o crescimento espiritual acontece melhor em comunidade. Cada grupo oferece um espaço seguro para se conectar, estudar a Palavra, orar juntos e apoiar uns aos outros na fé.",
      notFound: "Não encontra a sua comunidade?",
      notFoundDesc: "Contacte-nos e ajudá-lo-emos a encontrar o grupo que corresponde à sua temporada de vida.",
    },
    videos: {
      subtitle: "Reviva os nossos sermões, ensinos e momentos de louvor",
      subscribeTitle: "Subscreva o nosso canal",
      subscribeDesc: "Não perca nenhuma mensagem. Receba uma notificação a cada novo vídeo publicado.",
    },
    gallery: {
      subtitle: "Um olhar em imagens sobre os nossos momentos de celebração e comunhão",
      backToGallery: "Voltar à galeria",
      folderNotFound: "Pasta não encontrada",
    },
    login: {
      adminSpace: "Espaço de administração",
      email: "Email",
      password: "Palavra-passe",
      loggingIn: "A iniciar sessão...",
      noAccount: "Ainda não tem conta?",
      signUp: "Registar-se",
      backToSite: "Voltar ao site",
      loginError: "Início de sessão falhou",
      forgotPassword: "Esqueceu-se da palavra-passe?",
      resetPassword: "Redefinir palavra-passe",
      resetPasswordDesc: "Introduza o seu email para receber um link de redefinição.",
      resetPasswordSent: "Email enviado! Verifique a sua caixa de entrada e spam.",
      sendResetLink: "Enviar link",
    },
    register: {
      createAccount: "Criar conta de administrador",
      accessAdmin: "Aceda à área de administração do site",
      emailAddress: "Endereço de email",
      password: "Palavra-passe",
      minChars: "Mínimo 6 caracteres",
      confirmPassword: "Confirmar palavra-passe",
      creatingAccount: "A criar conta...",
      createMyAccount: "Criar a minha conta",
      alreadyAccount: "Já tem conta?",
      signIn: "Iniciar sessão",
      verifyEmail: "Verifique o seu email",
      verifyEmailDesc: "Um email de confirmação foi enviado para {email}. Clique no link no email para ativar a sua conta, depois inicie sessão.",
      verifyEmailNote: "Nota",
      verifyEmailSpam: "Se não receber o email, verifique o spam. O link é válido por 24 horas.",
      goToLogin: "Ir para a página de início de sessão",
      passwordMismatch: "As palavras-passe não coincidem",
      passwordMinLength: "A palavra-passe deve ter pelo menos 6 caracteres",
      registerError: "Registo falhou",
      backToSite: "Voltar ao site",
    },
    admin: {
      dashboard: "Painel",
      messages: "Mensagens",
      events: "Eventos",
      programs: "Programas",
      communities: "Comunidades",
      gallery: "Galeria",
      videos: "Vídeos",
      users: "Usuários",
      testimonials: "Testemunhos",
      settings: "Configurações",
    },
    language: {
      fr: "Francês",
      en: "Inglês",
      de: "Alemão",
      zh: "Chinês",
      es: "Espanhol",
      it: "Italiano",
      pt: "Português",
    },
  },
};